import { default308h22k6ofhww as default_0 } from '../../../../../lightning-server-shared/com/lightningkite/serialization/Defaults.mjs';
import { get_displayNamehv5zo902rjy4 as get_displayName } from './annotationReaders.mjs';
import { CLASS_getInstance14ex35co4jkrb as CLASS_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { Companion_getInstance17fcxlkqs50ig as Companion_getInstance } from './helpers.mjs';
import { MySealedClassSerializerInterface2tzma5kn4becp as MySealedClassSerializerInterface } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/MySealedClassSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Companion_instancegwok6qx7et5m as Companion_instance,
  FormSelector1zdq40oqbcvms as FormSelector,
  form1pdmcqj387954 as form,
  FormRendererv0cfjgipxuxv as FormRenderer,
  get_type3f1sl153qhh1c as get_type,
  get_nullable1f61etx34dvfo as get_nullable,
  get_annotation27eynvnd00ffx as get_annotation,
  get_handlesField2upaii4zzjnxm as get_handlesField,
  get_basePriority3aha966bwjyn2 as get_basePriority,
  priority7vn90mx06311 as priority,
  Generator2kgtccb0jt0mi as Generator,
} from './FormRenderer.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_atTop15ygil3ceeuhl as get_atTop,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { reactive2pl1t9wy5gll5 as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function MySealedFormRenderer$form$lambda$lambda(it) {
  return default_0(it.f49_1);
}
function MySealedFormRenderer$form$lambda$lambda_0(it) {
  return get_displayName(it.f49_1);
}
function MySealedFormRenderer$form$lambda$lambda$lambda(it) {
  return it;
}
var MySealedFormRendererClass;
function MySealedFormRenderer() {
  if (MySealedFormRendererClass === VOID) {
    class $ {
      constructor() {
        MySealedFormRenderer_instance = this;
        this.fe0_1 = 'Options';
        this.ge0_1 = CLASS_getInstance();
      }
      k20() {
        return this.fe0_1;
      }
      s11() {
        return this.ge0_1;
      }
      idu(module_0, selector) {
        return Companion_getInstance().kdu_1;
      }
      ddu(module_0, selector) {
        var tmp = selector.edu_1;
        return isInterface(tmp, MySealedClassSerializerInterface());
      }
      ldu(module_0, selector) {
        var tmp = selector.edu_1;
        var serializer = isInterface(tmp, MySealedClassSerializerInterface()) ? tmp : THROW_CCE();
        var tmp_0 = Companion_instance;
        var tmp_1 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_2 = tmp_0.mdu(module_0, this, tmp_1, VOID, VOID, ($this$FormRenderer, _unused_var__etf5q3, mutable) => {
          var tmp = (it) => {
            // Inline function 'kotlin.collections.find' call
            var tmp0 = serializer.v3t();
            var tmp$ret$1;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s = tmp0.m1();
              while (_iterator__ex2g4s.n1()) {
                var element = _iterator__ex2g4s.o1();
                if (element.i49_1(it)) {
                  tmp$ret$1 = element;
                  break $l$block;
                }
              }
              tmp$ret$1 = null;
            }
            var tmp0_elvis_lhs = tmp$ret$1;
            return tmp0_elvis_lhs == null ? first(serializer.v3t()) : tmp0_elvis_lhs;
          };
          var type = mutable.tak(tmp, MySealedFormRenderer$form$lambda$lambda);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$FormRenderer.pc());
          var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
          $this$FormRenderer.ebb(p, view);
          view.xbm(false);
          var tmp_0 = view.ibb(get_atTop(view), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(10)));
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp$ret$3 = view.hbb(FieldSemantic_getInstance());
          var tmp_1 = view.ibb(tmp_0, tmp$ret$3);
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (Select())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          var tmp_2 = _Constant___init__impl__v45mub(serializer.v3t());
          view_0.mcf(type, new (Constant())(tmp_2), MySealedFormRenderer$form$lambda$lambda_0);
          view.fbb(p_0, view_0);
          view.jbb(tmp_1, view_0);
          var tmp_3 = get_expanding(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.stack' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (Frame())(view.pc());
          var tmp0_elvis_lhs_1 = view.cbb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
          view.ebb(p_1, view_1);
          var $this$stack = view_1;
          reactive($this$stack, ($this$reactive) => {
            var type_0 = $this$reactive.baj(type);
            $this$stack.zb9();
            var tmp = type_0.f49_1;
            var tmp_0 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
            var tmp_1 = (it) => type_0.i49_1(it) ? it : default_0(type_0.f49_1);
            return form($this$stack, module_0, tmp_0, mutable.tak(tmp_1, MySealedFormRenderer$form$lambda$lambda$lambda));
          });
          view.fbb(p_1, view_1);
          view.jbb(tmp_3, view_1);
          $this$FormRenderer.fbb(p, view);
          return view;
        });
        return isInterface(tmp_2, FormRenderer()) ? tmp_2 : THROW_CCE();
      }
    }
    protoOf($).f94 = get_type;
    protoOf($).pdu = get_nullable;
    protoOf($).qdu = get_annotation;
    protoOf($).uds = get_handlesField;
    protoOf($).cdu = get_basePriority;
    protoOf($).rdu = priority;
    initMetadataForObject($, 'MySealedFormRenderer', VOID, VOID, [Generator()]);
    MySealedFormRendererClass = $;
  }
  return MySealedFormRendererClass;
}
var MySealedFormRenderer_instance;
function MySealedFormRenderer_getInstance() {
  if (MySealedFormRenderer_instance === VOID)
    new (MySealedFormRenderer())();
  return MySealedFormRenderer_instance;
}
//region block: exports
export {
  MySealedFormRenderer_getInstance as MySealedFormRenderer_getInstance3eio0tqn0zjx4,
};
//endregion

//# sourceMappingURL=MySealedFormRenderer.mjs.map
